import clsx from "clsx"

import { TruncatableText } from "@particles/index"

import NavTopBarBackButton from "@organisms/NavTopBar/NavTopBarBackButton/NavTopBarBackButton"

import styles from "./NavTopBarPageInnerTitle.module.scss"
import { NavTopBarPageInnerTitleProps } from "./NavTopBarPageInnerTitle.types"

export default function NavTopBarPageInnerTitle(props: NavTopBarPageInnerTitleProps) {
    const { backDestination, label } = props

    return (
        <div className={styles.base}>
            {backDestination && <NavTopBarBackButton destination={backDestination} />}
            <TruncatableText text={label} className={clsx(styles.label, "page-subtitle")} />
        </div>
    )
}
